<template>
    <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span class="text-center">Activity Logs </span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-subtitle class="px-4 pt-4">
                <h2>Details</h2>
            </v-card-subtitle>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="ProposalLogForm">
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                label="Description"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="description.value.value"
                                :error-messages="description.errorMessage.value"
                                clearable
                            >
                            </v-textarea>

                            <v-date-input
                                input-format="dd/mm/yyyy"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                label="Date"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="date.value.value"
                                :error-messages="date.errorMessage.value"
                                autocomplete="off"
                                clearable
                            >
                                <template #label>
                                    Date <span class="text-red-accent-4">*</span>
                                </template>
                            </v-date-input>

                            <v-autocomplete
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="workorder_status_id.value.value"
                                :items="getSalesWorkOrderStatusList"
                                :item-title="(item) => item.name"
                                item-value="id"
                                :error-messages="workorder_status_id.errorMessage.value"
                                autocomplete="off"
                                clearable
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                    Work Order Status
                                    <span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete>

                            <v-checkbox
                                label="Active"
                                v-model="status.value.value"
                                :error-messages="status.errorMessage.value"
                                density="compact"
                                variant="outlined"
                                hide-details
                                single-line
                                color="primary"
                                :true-value="1"
                                :false-value="0"
                            ></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                                class="bg-red"
                                variant="flat"
                                type="reset"
                                @click="closeDialog"
                            >
                                Close
                            </v-btn>
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
    name: "workOrderActivityLogSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                status: "1",
            }),
        },
    },
    data() {
        return {
            localDialog: this.dialog,
            selectedImage: null,
            errorMessages: "",
            loading: false,
            isEntryMode: true,
        };
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {},
    },
    created() {
        // if (this.$store.getters.getSalesProposalStatus.length === 0) {
            this.$store.dispatch("getSalesProposalStatus");
        // }
        // if (this.$store.getters.getSalesWorkOrderStatusList.length === 0) {
            this.$store.dispatch("getSalesWorkOrderStatusList");
        // }
    },
    computed: {
        getSalesProposalStatus() {
            return this.$store.getters.getSalesProposalStatus;
        },
        getSalesWorkOrderStatusList() {
            console.log(this.$store.getters.getSalesWorkOrderStatusList)
            return this.$store.getters.getSalesWorkOrderStatusList;
        },
    },
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                description: yup.string().nullable().label("Description"),
                date: yup.string().required().label("Date"),
                workorder_status_id: yup.number().required().label("Proposal Status"),
                remarks: yup.string().nullable().label("Remarks"),
                status: yup.number().required().label("Status"),
            }),
        });
        
        const workorder_id = useField("workorder_id");
        const description = useField("description");
        const date = useField("date");
        const workorder_status_id = useField("workorder_status_id");
        const remarks = useField("remarks");
        const status = useField("status");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();

        const submit = handleSubmit((values) => {
            values.date = formattedDate(date.value.value);
            values.workorder_id = props.data.id;
            store.dispatch("saveSalesWorkOrderActivityLog", values)
                .then((response) => {
                    resetForm();
                    emit("update:dialog", false);
                    emit("update-success");
                    emit("update:work-orders");
                    toast.success(response.data.message);
                })
                .catch((error) => {
                    toast.error(error.response?.data?.message || "Something went wrong");
                }
            );
        });

        return {
            submit,
            workorder_id,
            description,
            date,
            workorder_status_id,
            remarks,
            errorMessages,
            resetForm,
            status,
            loading,
        };
    },
    mounted() {
        console.log(this.props);
    },
};
</script>
